import React from "react";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";
import { Link } from '@material-ui/core';
import { SIZE, WIDTH, HEIGHT, REL, TARGET, MESSAGE, FONTSIZE, COLOR } from './InfoIconConstants';
import CustomTooltip from "../Tooltip/CustomMUITooltip";

const CustomHelpIcon = ({ msg, link }) => {
  return (
    <CustomTooltip title={msg}  placement="top">
      <Link href={link} target={TARGET} rel={REL}>
        <IconButton aria-label={msg} size={SIZE}>
          <HelpIcon style={{ color: COLOR, width: WIDTH, height: HEIGHT, "font-size": FONTSIZE}} />
        </IconButton>
      </Link>
    </CustomTooltip>
  );
};

export default CustomHelpIcon;